import isValidEmail from "~reports/email/isValidEmail";

export interface SmtpAddressInput {
	adminOnly?: boolean;
	displayName: string;
	email: string;
}

export const MAX_SMTP_ADDRESSES = 25;

export const normalizeSmtpAddressEmail = (email: string): string => email.trim().toLowerCase();

export const canAddSmtpAddress = (candidateEmail: string, existing: readonly SmtpAddressInput[]): boolean => {
	if (existing.length >= MAX_SMTP_ADDRESSES) return false;
	const normalized = normalizeSmtpAddressEmail(candidateEmail);
	if (!isValidEmail(normalized)) return false;
	return !existing.some((address) => address.email.toLowerCase() === normalized);
};
